import { Card, CardBody, Col } from "reactstrap";
import { H4, Image, P } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";

const AddTitleCardImage = () => {
  return (
    <Col xxl="6" sm="6" xl="4" className="box-col-4">
      <Card className="common-hover">
        <CardBody>
          <div className="creative-wrapper">
            <Image className="img-fluid" src={dynamicImage("other-images/mountain.jpg")} alt="background image" />
            <div className="creative-info w-100">
              <H4 className="text-white text-truncate">Add the title of the card</H4>
              <P className="text-white">This is an example card for you to use. you are able to include subtitles in your according.</P>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default AddTitleCardImage;
